import React from "react";

import "./styles.scss";

interface Props {
  active?: boolean;
  label?: string;
  onClick?: () => void;
}

const RadioButton = ({ active, label, onClick }: Props) => {
  return (
    <div className="radio-button-wrapper" onClick={onClick}>
      <div className="radio-button-container">
        {active && <div className="radio-button-dot"></div>}
      </div>
      {!!label && (
        <span className={`radio-button-label ${active ? "radio-button-label-active" : ""}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default RadioButton;
